<edu-card class="settings-card">
  <h2 edu-card-title>Group visibility</h2>
  <p class="desc">
    When enabled, every team member can see all groups in this organization.
    When disabled, members only see the groups they are assigned to.
  </p>

  <div class="toggle-row">
    <div class="toggle-label">
      <span class="toggle-title">Show all groups to everyone</span>
      <span class="toggle-hint" *ngIf="!canManage">You do not have permission to change this setting.</span>
    </div>

    <button
      type="button"
      class="switch"
      role="switch"
      [class.on]="enabled()"
      [attr.aria-checked]="enabled()"
      [disabled]="!canManage || isSaving()"
      (click)="toggle()"
    >
      <span class="knob"></span>
    </button>
  </div>
</edu-card>
